export const ADDRESS_FORCE_SAVE_VALIDATION_CALLS = 2;
